import React from 'react'
import { Grid } from '@material-ui/core'
import { useStyles } from './Styles'
import { FormattedMessage } from 'react-intl'
import { ServiceConsumer } from '../../../../ServiceContext'
import PageTitle from '../../PageTitle/PageTitle'
import { FormLoader } from '../../../Loader/FormLoader'
import Alert from '@material-ui/lab/Alert'
import ServiceForm from './ServiceForm'
import { NamedRoutes } from '../../../../routes'
import BreadCrumb from '../../BreadCrumb'

const ServiceEditContent = ({ pageTitle }) => {
  const classes = useStyles()
  return (
    <>
      <BreadCrumb links={[
        {
          key: 'BreadcrumbLink-1',
          name: <FormattedMessage id='Sidebar.Links.Services'/>,
          link: NamedRoutes.subscription.service.list
        }
      ]} current={pageTitle ?? <FormattedMessage id='Services.List.AddService.Title'/>}/>
      <PageTitle title={pageTitle ?? <FormattedMessage id='Services.List.AddService.Title'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.EditProfileContentContainer}>
          <div className={classes.EditProfileContent}>
            <ServiceConsumer>
              {({ serviceDataLoading, serviceDataFailure, serviceData, handleServiceSubmit, pageAction }) => (
                <>
                  {!!serviceDataLoading && <FormLoader loading={true}/>}
                  {!!serviceDataFailure &&
                  <Alert severity="error"><FormattedMessage id='UpdateProfile.FormErrorAlert'/></Alert>
                  }
                  {pageAction === 'add' ?
                    <ServiceForm currentDate={{}} onSubmit={handleServiceSubmit}/> :
                    (!!serviceData && !!Object.keys(serviceData).length &&
                      <ServiceForm currentDate={serviceData} onSubmit={handleServiceSubmit}/>)
                  }
                </>
              )}
            </ServiceConsumer>
          </div>
        </Grid>
      </Grid>
    </>
  )
}

export default ServiceEditContent
